<template>
    <div>
        <div>
            <b>Eventi e scadenze</b>
        </div>
        <div>
            <!-- <x-alert-info v-if="session()->has('messaggio')"></x-alert-info> -->


            <table>
                <tbody>
                    <tr v-for="(event, index) in event_google">

                        <td style="width: 20%;">
                            <label>Titolo</label>
                            <input required type="input" class="form-control" v-model="event.name" :name="'events['+ index +'][name]'" :loading="loading">
                            <input type="hidden" v-model="event.id" :name="'events['+ index +'][id]'">
                            <input type="hidden" v-model="event.id_google_calendar" :name="'events['+ index +'][id_google_calendar]'">

                        </td>
                         <td style="width: 25%; padding-left: 10px;">
                            <label>Descrizione</label>
                            <textarea class="form-control" v-model="event.description" :name="'events['+ index +'][description]'" :loading="loading"></textarea>
                        </td>

                        <td style="width: 5%; padding-left: 10px;">
                            <label>Data</label>
                            <input @input="chageStartDate(index)" required type="datetime-local" class="form-control"  v-model="event.startDateTime" :name="'events['+ index +'][startDateTime]'" :loading="loading">
                        </td>
                        <td style="text-align:center; width: 10%;">
                            <label>Intero giorno</label>
                            <input @click="setEventFullDay(index)" type="checkbox" class="" v-model="event.full_day" :name="'events['+ index +'][full_day]'" :loading="loading">
                        </td>
                        <td style="width: 10%; padding-left: 10px;">
                            <label>Durata (h)</label>
                            <input required :readonly="event.full_day" type="number" class="form-control" v-model="event.time" :name="'events['+ index +'][time]'"  :loading="loading" min="1" max="24">
                        </td>
                        <td style="width: 20%; padding-left: 10px;">
                            <label>Luogo</label>
                            <input type="input" class="form-control" v-model="event.location" :name="'events['+ index +'][location]'"  :loading="loading">
                        </td>
                        <td style="width: 10%; padding-left: 10px;">
                            <label>Colore</label>
                            <select required @change="updateColorEvent(index)" type="input" class="form-control" v-model="event.colorId" :name="'events['+ index +'][colorId]'" :loading="loading">
                                <option v-for="color_event in colors" :value=color_event.id>{{color_event.text}}</option>
                            </select>
                        </td>
                        <td style="width: 5%; padding-left:10px; padding-top:20px;">
                            <div :style="event.colorStyle"></div>
                        </td>
                        <td style="width: 5%; padding-top: 15px;">
                            <button @click="deleteRow(index)" type="button" class="btn"><i class="fas fa-trash"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <div>
                <a @click="addRow" class="btn btn-secondary" :loading="loading">Aggiungi</a>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    export default {
        props:{
            events:{type:Array},
        },
        data(){
            let event_google   = this.events;
            let colors = this.getListColor();

            return {
                event_google,
                colors,
                error:null,
                message:null,
                loading:false,
            };
        },
        mounted: function () {
            for(let i = 0; i < this.event_google.length; i++) {
                this.colors = this.getListColor();
                this.updateColorEvent(i);
                this.checkFullDayEvent(i);
            }
        },
        methods: {
            addRow() {
                let value =  this.event_google.lenght;
                this.error = null;
                this.event_google.push({
                    id:null,
                    id_google_calendar:null,
                    full_day:false,
                    time:1,
                    startDateTime:null,
                    name: "",
                    description: "",
                    location: "",
                    status:"confirmed",
                    colorId: 7,
                    colorStyle: "padding-left: 20px; width: 30px; height: 30px; background-color:#039be5;",
                });
            },
            checkFullDayEvent(index) {
                if(index >= 0 && index < this.event_google.length) {
                    let ora             = new Date(this.event_google[index].startDateTime).getHours();
                    let minuti          = new Date(this.event_google[index].startDateTime).getMinutes();
                    let secondi         = new Date(this.event_google[index].startDateTime).getSeconds();
                    let millisecondi    = new Date(this.event_google[index].startDateTime).getMilliseconds();
                    if(this.event_google[index].time == 24 && ora == 0 && minuti == 0 && secondi == 0 && millisecondi == 0) {
                        this.event_google[index].full_day = true;
                    }
                }
            },
            setEventFullDay(index) {
                if(index >= 0 && index < this.event_google.length) {
                    if(!this.event_google[index].full_day) {
                        this.event_google[index].time = 24;
                        var startDay = new Date(this.event_google[index].startDateTime);
                        startDay.setHours(0,0,0,0);
                        this.event_google[index].startDateTime = moment(startDay).format('YYYY-MM-DDTHH:mm');
                    }
                }
            },
            chageStartDate(index) {
                if(index >= 0 && index < this.event_google.length) {
                    let ora             = new Date(this.event_google[index].startDateTime).getHours();
                    let minuti          = new Date(this.event_google[index].startDateTime).getMinutes();
                    let secondi         = new Date(this.event_google[index].startDateTime).getSeconds();
                    let millisecondi    = new Date(this.event_google[index].startDateTime).getMilliseconds();

                    console.log("ora: " + ora + " - minuti: " + minuti + " - secondi: "+ secondi +" - millisecondi: " + millisecondi);

                    if(ora !== 0 || minuti !== 0 || secondi !== 0 || millisecondi !== 0) {
                        this.event_google[index].full_day = false;
                    }
                }
            },
            deleteRow(index) {
                if(this.event_google[index].id === null) {
                    this.event_google.splice(index, 1);
                }
                else {
                    if(confirm("Confermi di voler cancellare l'evento dal fascicolo?")) {
                        this.loading = true;
                        this.error = null;
                        this.message = null;

                        axios.delete("/event/" + this.event_google[index].id + "/delete")
                            .then((response) => {
                                this.error = response.data.result !== "ok" ? "Non sei autorizzato a cancellare questo evento" : null;
                                this.message = response.data.result === "ok" ? "Evento cancellato con successo" : null;
                                if (response.data.result == "ok") {
                                    this.event_google.splice(index, 1);
                                }
                            })
                            .catch((error) => {
                                this.error = error;
                            })
                            .finally(() => {
                                this.loading = false;
                            }
                        );
                    }
                }
            },
            updateColorEvent(index) {
                if(index >= 0 && index < this.event_google.length) {
                    this.event_google[index].colorStyle = this.getColorStyle(this.event_google[index].colorId);
                }
            },
            getColorStyle(colorId) {
                let style = "padding-left: 20px; width: 30px; height: 30px;";
                for(let i = 0; i < this.colors.length; i++) {
                    if(this.colors[i].id == colorId) {
                        style += "background-color:" + this.colors[i].rgb + ";";
                        break;
                    }
                }
                return style;
            },
            getListColor() {
                let colors = [
                    {
                        text:"Lavanda",
                        id:1,
                        rgb: "#7986cb"
                    },
                    {
                        text:"Verde chiaro",
                        id:2,
                        rgb: "#33b679"
                    },
                    {
                        text:"Viola",
                        id:3,
                        rgb: "#8e24aa"
                    },
                    {
                        text:"Rosa",
                        id:4,
                        rgb: "#e67c73"
                    },
                    {
                        text:"Giallo",
                        id:5,
                        rgb: "#f6c026"
                    },
                    {
                        text:"Arancione",
                        id:6,
                        rgb: "#f5511d"
                    },
                    {
                        text:"Azzurro",
                        id:7,
                        rgb: "#039be5"
                    },
                    {
                        text:"Grigio",
                        id:8,
                        rgb: "#616161"
                    },
                    {
                        text:"Blu",
                        id:9,
                        rgb: "#3f51b5"
                    },
                    {
                        text:"Verde scuro",
                        id:10,
                        rgb: "#0b8043"
                    },
                    {
                        text:"Rosso",
                        id:11,
                        rgb: "#d60000"
                    },
                ];
                return colors;
            }
        },
    }
</script>
